import React, { useState } from "react";
import {
    Box,
    Tooltip,
    Typography,
    Divider,
    Stack,
    styled,
} from "@mui/material";

const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        PopperProps={{ disablePortal: true }}
        classes={{ popper: className }}
    />
))(({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: "white",
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[3],
        maxWidth: 300,
        borderRadius: 8,
        fontSize: theme.typography.body2.fontSize,
    },
    [`& .MuiTooltip-arrow`]: {
        color: "white",
    },
}));

const StandardText = ({ text, style, copyable = true }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        if (!copyable) return;
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Copy failed", err);
        }
    };

    return (
        <Box>
            <StyledTooltip
                title={
                    copyable ? (
                        <Stack>
                            <Typography
                                fontSize="10px"
                                textAlign="center"
                                style={style}
                            >
                                {text}
                            </Typography>
                            <Divider sx={{ my: 1 }} />
                            <Typography
                                variant="caption"
                                sx={{}}
                                fontSize="10px"
                                textAlign="center"
                            >
                                {copied ? "Copied!" : "Click to copy"}
                            </Typography>
                        </Stack>
                    ) : (
                        <Typography
                            fontSize="10px"
                            textAlign="center"
                            style={style}
                        >
                            {text}
                        </Typography>
                    )
                }
                arrow
                placement="top"
            >
                <Box
                    onClick={handleCopy}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1,
                        cursor: "pointer",
                        userSelect: "none",
                        maxWidth: "100%",
                    }}
                >
                    <Box
                        sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            minWidth: 0,
                            flexGrow: 1,
                        }}
                    >
                        {text}
                    </Box>
                </Box>
            </StyledTooltip>
        </Box>
    );
};

export default StandardText;
